document.addEventListener("DOMContentLoaded", function () {
  const videoElement = document.querySelector(".main-banner__video");
  const sourceElement = videoElement
    ? videoElement.querySelector("source")
    : null;
  const buttons = document.querySelectorAll(".main-banner__button");

  function updateProgress() {
    const activeBtn = document.querySelector(
      ".main-banner__button--active"
    );
    const activeBtnProgress = activeBtn.querySelector(".main-banner__button-fill");
    if (videoElement && videoElement.duration && activeBtn) {
      const percent = (videoElement.currentTime / videoElement.duration) * 100;
      activeBtnProgress.style.width = percent + "%";

      if (percent >= 100) {
        const nextBtn = activeBtn.nextElementSibling;
        if (nextBtn) {
          // If there is a next button, click it
          nextBtn.click();
        } else {
          // If no next button, loop back to the first button
          buttons[0].click();
        }
      }
    }
    requestAnimationFrame(updateProgress);
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const newVideoUrl = button.getAttribute("data-video");

      console.log("Switching to video:", newVideoUrl);

      if (sourceElement && newVideoUrl) {
        sourceElement.setAttribute("src", newVideoUrl);
        videoElement.load();

        videoElement.addEventListener("loadeddata", function onLoaded() {
          videoElement.play();
          videoElement.removeEventListener("loadeddata", onLoaded);
        });
      }

      buttons.forEach((btn) =>
        btn.classList.remove("main-banner__button--active")
      );
      button.classList.add("main-banner__button--active");

      // Reset progress bars
      buttons.forEach((btn) => {
        const fill = btn.querySelector(".main-banner__button-fill");
        if (fill) fill.style.width = "0%";
      });
    });
  });

  if (buttons.length) {
    buttons[0].classList.add("main-banner__button--active");
  }

  requestAnimationFrame(updateProgress);
});
